import { Route } from "react-router-dom";
import InstitutionalIndex from "./Pages/Institutional/InstitutionalIndex";
import CorporateAccountAgreement from "./Pages/Institutional/Components/CorporateAccountAgreement";
import SubscriptionAgreement from "./Pages/Register/Components/SubscriptionAgreements";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import UsageConditionAgreement from "./Pages/Register/Components/UsageConditionAgreement";
import ContractRuleAgreement from './Pages/Register/Components/ContractRuleAgreement';
import Login from "./Pages/Login/Login";



export const accountRouteList = [
  <Route key={"AccountRouteList"}>
     <Route path="/kurumsal/kayit" element={<InstitutionalIndex />}  />
     <Route path="/giris-yap" element={<Login isPage={true}  />}  />
     <Route path="/kurumsal/hesab/sozlesmesi" element={<CorporateAccountAgreement />}  />
     <Route path="/abonelik/sozlesmesi" element={<SubscriptionAgreement />}  />
     <Route path="/kullanim-kosullar-sozlesmesi" element={<UsageConditionAgreement/>}  />
     {/* <Route path="/sozlesme-kurallar" element={<ContractRuleAgreement/>}  /> */}
     <Route path="/Account/SetPassword" element={<ResetPassword />} />
  </Route>,
];
